/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/user',
    component: Layout,
    name: 'User',
    menuid: 10,
    systemtypeid: 0,
    meta: {
      title: 'UserTitle',
      icon: 'peoples'
    },
    children: [  
      {
        path: 'index',
        component: () => import('@/views/base/user/base/list'),
        name: 'UserBaseList',
        menuid: 12,
        systemtypeid: 0,
        meta: {title: 'UserBaseList', icon: 'people'}
      },  
      {
        path: 'apply',
        component: () => import('@/views/base/user/apply/list'),
        name: 'UserApplyList',
        menuid: 141,
        systemtypeid: 0,
        meta: {title: 'UserApplyList', icon: 'edit'}
      }, 
      {
        path: 'list',
        component: () => import('@/views/base/key/base/list'),
        name: 'KeyBaseManage',
        menuid: 45,
        systemtypeid: 0,
        meta: {title: 'KeyBaseManage', icon: 'clipboard'}
      }, 
      {
        path: 'disable',
        component: () => import('@/views/base/user/disable/list'),
        name: 'UserDisabledList',
        menuid: 170,
        systemtypeid: 0,
        meta: {title: 'UserDisabledList', icon: 'lock'}
      }, 
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/user.js